export const ADMIN_CAPABILITIES = Object.freeze({
  CONSOLE_READ: 'admin.console.read',
  ANALYTICS_READ: 'admin.analytics.read',
  ANALYTICS_EXPORT: 'admin.analytics.export',
  USERS_READ: 'admin.users.read',
  USERS_MANAGE: 'admin.users.manage',
  CONTENT_MANAGE: 'admin.content.manage',
  AI_READ: 'admin.ai.read',
  AI_MANAGE: 'admin.ai.manage',
  AI_SETTINGS_MANAGE: 'admin.ai.settings.manage',
  OPERATIONS_READ: 'admin.operations.read',
  OPERATIONS_MANAGE: 'admin.operations.manage',
  TRADING_MANAGE: 'admin.trading.manage',
  ACCESS_READ: 'admin.access.read',
  ACCESS_ROLES_MANAGE: 'admin.access.roles.manage',
  AUDIT_READ: 'admin.audit.read',
  AUDIT_EXPORT: 'admin.audit.export',
  SECURITY_READ: 'admin.security.read'
})

export const ADMIN_CAPABILITY_VALUES = Object.freeze(
  Object.values(ADMIN_CAPABILITIES)
)
